import { RoleGroupType, UserRoleType } from '@vi-iot/client';

export function mapUserRoleTypeToGroupType(role: UserRoleType): RoleGroupType {
  switch (role) {
    case UserRoleType.endUser:
      return RoleGroupType.User;

    case UserRoleType.maintainer:
    case UserRoleType.maintainerDeputy:
    case UserRoleType.maintainerAdmin:
    case UserRoleType.maintainerCEO:
      return RoleGroupType.Maintainer;

    case UserRoleType.supportLocalReadOnly:
    case UserRoleType.supportLocalReadWrite:
    case UserRoleType.supportLocalDepartmentManagement:
      return RoleGroupType.SupportLocal;

    case UserRoleType.supportLocalReadWriteWithRemoteDiagnosis:
      return RoleGroupType.SupportLocalReadWriteWithRemoteDiagnosis;

    case UserRoleType.supportInternational:
      return RoleGroupType.SupportInternational;

    case UserRoleType.supportInternationalWithRemoteDiagnosis:
      return RoleGroupType.SupportInternationalWithRemoteDiagnosis;

    case UserRoleType.admin:
      return RoleGroupType.Admin;

    default:
      return RoleGroupType.User;
  }
}
